import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";

type FormState = FormUnit<boolean>;

type Input = GetFormInput<FormState>;

function init(initial: Input): FormState {
	return FormUnit(initial);
}

const FormState = {
	init,
} as const;

export { FormState };
